/* eslint-disable unicorn/consistent-function-scoping */
import { computed, inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CollaborationAttachmentsDataService } from '@ffd/api-client';
import { pathParameter, TagEvent, TagPusherService } from '@libs/shared-services';
import { multiDownload } from '@libs/utils';
import { take } from 'rxjs';

@Injectable()
export class PreviewAttachmentDialogService {
  private readonly collaborationsDataService = inject(CollaborationAttachmentsDataService);
  private readonly route = inject(ActivatedRoute);
  private readonly tagPusherService = inject(TagPusherService);

  private readonly patientId = computed(() => this.route.snapshot.paramMap.get(pathParameter('patientId')));

  public downloadButtonClick(): void {
    this.tagPusherService.pushTag({
      event: TagEvent.CollaborationDownloadButtonTap,
      location: 'collaboration_message',
      patient_id: this.patientId() || undefined,
    });
  }

  public downloadAttachment(attachmentId: string, file?: File): void {
    // If a file is provided, we assume it's a local file and we can download it directly.
    if (file) {
      this.tagPusherService.pushTag({
        event: TagEvent.CollaborationDownloadFinished,
        patient_id: this.patientId() || undefined,
      });
      multiDownload([URL.createObjectURL(file)]);
    } else {
      this.collaborationsDataService
        .getDownloadLinkForOriginalAttachment(attachmentId, 'body', true)
        .pipe(take(1))
        .subscribe({
          next: async (response) => {
            try {
              await multiDownload([response.url]);
              this.tagPusherService.pushTag({
                event: TagEvent.CollaborationDownloadFinished,
                patient_id: this.patientId() || undefined,
              });
            } catch (error) {
              console.error('Error during download', error);
            }
          },
          error: (error) => {
            console.error('Error in downloadAttachment', error);
          },
        });
    }
  }
}
